import { TUI_ENGLISH_LANGUAGE_COUNTRIES } from '@taiga-ui/i18n/languages/english';
const TUI_TURKISH_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Kart No', 'Kart Numarası'],
  cardExpiry: ['SKT', 'Son Kullanma']
};
const TUI_TURKISH_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Solid color', 'Gradient'],
  toolbarTools: {
    undo: 'Geri al',
    redo: 'İleri Al',
    font: 'Yazı Tipi',
    fontStyle: 'Yazı stili',
    fontSize: 'Yatı Boyutu',
    bold: 'Kalın',
    italic: 'İtalik',
    underline: 'Altı Çizi',
    strikeThrough: 'Üstü Çizili',
    justify: 'Hizala',
    justifyLeft: 'Sola yasla',
    justifyCenter: 'Ortala',
    justifyRight: 'Sağa yasla',
    justifyFull: 'Doldur',
    list: 'Liste',
    indent: 'Girinti',
    outdent: 'Çıkıntı',
    unorderedList: 'Noktalı liste',
    orderedList: 'Numerik liste',
    quote: 'Alıntı',
    foreColor: 'Renk',
    backColor: 'Arka plan rengi',
    hiliteColor: 'hiliteColor',
    clear: 'Formatı Temizle',
    link: 'Link',
    attach: 'Dosya Ekle',
    tex: 'TeX Ekle',
    code: 'Kod',
    image: 'Resim Ekle',
    insertHorizontalRule: 'Satır Ekle',
    superscript: 'Üst Simge',
    subscript: 'Alt Simge',
    insertTable: 'Insert table',
    hiliteGroup: 'Hilite group',
    insertGroup: 'Insert group',
    removeGroup: 'Remove group',
    insertAnchor: 'Insert anchor',
    mergeCells: 'Merge cells',
    splitCells: 'Split cells',
    rowsColumnsManaging: 'Managing rows and columns',
    cellColor: 'Cell color',
    setDetails: 'Details',
    removeDetails: 'Remove details'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'anchor'
  },
  editorTableCommands: [['Insert column before', 'Insert column after'], ['Insert row before', 'Insert row after'], ['Delete column', 'Delete row']],
  editorCodeOptions: ['Code in the text', 'Code in block'],
  editorFontOptions: {
    small: 'Small',
    normal: 'Normal',
    large: 'Large',
    title: 'Title',
    subtitle: 'Subtitle'
  }
};
const TUI_TURKISH_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Göster/Hizle',
  paginationTexts: {
    pages: 'Sayfa',
    linesPerPage: 'Görüntülenen',
    of: 'toplam'
  }
};
const TUI_TURKISH_LANGUAGE_CORE = {
  months: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
  close: 'Kapat',
  clear: 'Alanı temizle',
  nothingFoundMessage: 'Kayıt Bulunamadı',
  defaultErrorMessage: 'Değer hatalı',
  spinTexts: ['Geri', 'İleri'],
  shortWeekDays: ['Ptsi', 'Salı', 'Çrş', 'Prş', 'Cma', 'Ctsi', 'Pzr'],
  // TODO: i18n replace with current language countries list
  countries: TUI_ENGLISH_LANGUAGE_COUNTRIES
};
const TUI_TURKISH_LANGUAGE_KIT = {
  cancel: 'İptal Et',
  done: 'Tamam',
  more: 'Daha Fazla',
  otherDate: 'Farklı bir tarih...',
  showAll: 'Show all',
  hide: 'Hide',
  mobileCalendarTexts: ['Gün seç', 'Aralık seç', 'Günleri seçin'],
  range: ['dan', 'a'],
  countTexts: ['Artı', 'Eksi'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['Göster', 'Gizle'],
  copyTexts: ['Kopyala', 'Kopyalandı'],
  shortCalendarMonths: ['Ock', 'Şbt', 'Mart', 'Nsn', 'Mays', 'Hzrn', 'Tmmz', 'Ağu', 'Eyl', 'Ekm', 'Kas', 'Aral'],
  pagination: ['Önceki', 'Sonraki'],
  fileTexts: {
    loadingError: 'Yükleme Hatası',
    preview: 'Öz İzleme',
    remove: 'Kaldır'
  },
  inputFileTexts: {
    defaultLabelSingle: 'veya\u00A0buraya\u00A0sürükleyin',
    defaultLabelMultiple: 'veya\u00A0buraya\u00A0sürükleyin',
    defaultLinkSingle: 'Dosya seç',
    defaultLinkMultiple: 'Dosyaları seç',
    maxSizeRejectionReason: 'Dosya boyutu fazla',
    formatRejectionReason: 'Dosya formatı yanlış',
    drop: 'Dosyayı buraya bırakın',
    dropMultiple: 'Dosyaları buraya bırakın'
  },
  multiSelectTexts: {
    all: 'Hepsini seç',
    none: 'Hiçbirini Seçme'
  },
  confirm: {
    yes: 'Evet',
    no: 'Hayır'
  },
  previewTexts: {
    rotate: 'Döndür'
  },
  zoomTexts: {
    zoomOut: 'Uzaklaştır',
    zoomIn: 'Yakınlaştır',
    reset: 'Sıfırla'
  },
  phoneSearch: 'Ülke veya kodu yazın'
};
const TUI_TURKISH_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_TURKISH_LANGUAGE = {
  name: 'turkish',
  ...TUI_TURKISH_LANGUAGE_CORE,
  ...TUI_TURKISH_LANGUAGE_KIT,
  ...TUI_TURKISH_LANGUAGE_ADDON_TABLE,
  ...TUI_TURKISH_LANGUAGE_ADDON_COMMERCE,
  ...TUI_TURKISH_LANGUAGE_ADDON_EDITOR,
  ...TUI_TURKISH_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_TURKISH_LANGUAGE, TUI_TURKISH_LANGUAGE_ADDON_COMMERCE, TUI_TURKISH_LANGUAGE_ADDON_EDITOR, TUI_TURKISH_LANGUAGE_ADDON_TABLE, TUI_TURKISH_LANGUAGE_CORE, TUI_TURKISH_LANGUAGE_KIT, TUI_TURKISH_LANGUAGE_LAYOUT };
